import { render, staticRenderFns } from "./Keyboard65LessSplit.vue?vue&type=template&id=70991d57&scoped=true&"
import script from "./Keyboard65LessSplit.vue?vue&type=script&lang=js&"
export * from "./Keyboard65LessSplit.vue?vue&type=script&lang=js&"
import style0 from "./Keyboard65LessSplit.vue?vue&type=style&index=0&id=70991d57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70991d57",
  null
  
)

export default component.exports